<div class="dashboard-container">
    <h2>KSolve User Management</h2>
    <div *ngIf="loading">Loading users...</div>

    <div class="table-container" [hidden]="loading">
        <mat-form-field appearance="outline">
            <mat-label>Filter</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Search users" #input>
        </mat-form-field>

        <table mat-table [dataSource]="dataSource" matSort class="users-table">

            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
                <td mat-cell *matCellDef="let row"> {{row.id}} </td>
            </ng-container>

            <ng-container matColumnDef="loginId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Login ID (Email) </th>
                <td mat-cell *matCellDef="let row"> {{row.loginId}} </td>
            </ng-container>

            <ng-container matColumnDef="emailVerified">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Verified </th>
                <td mat-cell *matCellDef="let row">
                    <mat-icon [color]="row.emailVerified ? 'primary' : 'warn'">
                        {{row.emailVerified ? 'check_circle' : 'cancel'}}
                    </mat-icon>
                </td>
            </ng-container>

            <ng-container matColumnDef="created">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Created At </th>
                <td mat-cell *matCellDef="let row"> {{row.created | date:'short'}} </td>
            </ng-container>

            <ng-container matColumnDef="updated">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Updated At </th>
                <td mat-cell *matCellDef="let row"> {{row.updated | date:'short'}} </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> Actions </th>
                <td mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
                    <button mat-icon-button color="primary" (click)="editUser(row)" aria-label="Edit">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button color="warn" (click)="deleteUser(row)" aria-label="Delete">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row">
            </tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="6">No data matching the filter "{{input.value}}"</td>
            </tr>
        </table>
    </div>

</div>